"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var EffectValue_1 = require("./EffectValue");
var CheckboxEffectValue = (function (_super) {
    tslib_1.__extends(CheckboxEffectValue, _super);
    function CheckboxEffectValue(rawData, version) {
        return _super.call(this, EffectValue_1.EffectValueType.CheckBox, rawData, version) || this;
    }
    return CheckboxEffectValue;
}(EffectValue_1.EffectValue));
exports.CheckboxEffectValue = CheckboxEffectValue;
//# sourceMappingURL=CheckboxEffectValue.js.map